import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDefaultHomePath } from '../../utils/HomeNavigation';

import './ErrorPages.scss';

const PermissionDenied = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const goHome = () => {
    navigate(getDefaultHomePath());
  };

  return (
    <div className="not-found-container">
      <h1 className="not-found-title">403</h1>
      <p className="not-found-message">{t('permission_denied_message')}.</p>
      <button className="not-found-button" onClick={goHome}>{t('go_home')}</button>
    </div>
  );
};

export default PermissionDenied;
